export default {"src":"/_next/static/media/ollie-box.483072d1.svg","height":82,"width":115,"blurWidth":0,"blurHeight":0};